import { createEditingStyle } from 'ol/style/Style';
import { unByKey } from 'ol/Observable';

import { GeometryType } from 'cadenza/map/geom/geometry-type';
import { InteractionGroup } from 'cadenza/map/interactions/interaction-group';
import { SnapInteraction } from 'cadenza/map/interactions/snap-interaction';
import { convertStyle } from 'cadenza/map/convert-style';
import { cloneStyle } from 'cadenza/map/style/style-util';
import { ClassicDrawInteraction } from 'cadenza/map/interactions/classic/classic-draw-interaction';

/**
 * @deprecated Will be removed when Classic and Workbook will be separated.
 * If you're looking for a similar class checkout
 * {@link import('cadenza/map/interactions/common-draw-interaction-group.js').CommonDrawInteractionGroup}
 */
export class ClassicSketchDrawInteractionGroup extends InteractionGroup {

  #featureStyle;
  #paletteItem;
  #eventKeys;

  constructor (paletteItem, source, map,
    {
      type = paletteItem.type,
      featureStyle = convertStyle(paletteItem.style)
    } = {}
  ) {
    const drawInteraction = new ClassicDrawInteraction(map, {
      source,
      type,
      isTextModeDrawing: paletteItem.type === 'text',
      featureStyle,
      style: createEditingStyle()[GeometryType.POINT] // show only a point at the mouse cursor and no lines
    });

    drawInteraction.on('change:active', event => {
      if (!event.oldValue) {
        this.#onDrawInteractionActivation(drawInteraction);
      } else {
        this.#onDrawInteractionDeactivation();
      }
    });

    const snapInteraction = new SnapInteraction({ source });
    super(drawInteraction, snapInteraction);
    this.#paletteItem = paletteItem;
    this.#featureStyle = featureStyle;
  }

  getPaletteItem () {
    return this.#paletteItem;
  }

  #onDrawInteractionActivation (drawInteraction) {
    this.#eventKeys = [ drawInteraction.on('drawstart', event => this.#onDrawStart(event)) ];
  }

  #onDrawInteractionDeactivation () {
    unByKey(this.#eventKeys);
  }

  #onDrawStart (event) {
    event.feature.setStyle(cloneStyle(this.#featureStyle));
    event.feature.type = this.#paletteItem.type;
  }

}
